import { ALERT_MESSAGE } from "../config";

class ErrorService {
  constructor() {
    this.subscribers = [];
    this.errorTimeStamps = {};
    this.alerts = [];
  }

  subscriber(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== callback);
    };
  }

  notifySubscribers() {
    this.subscribers.forEach((callback) => callback(this.alerts));
  }

  handleError(error) {
    const error_id = error.status;
    const now = Date.now();
    const errorMessage = error.message || ALERT_MESSAGE.UNKNOW_ERROR_STATUS;
    const errorDetail = error.detail || ALERT_MESSAGE.DEFAULT_DETAIL;

    this.alerts = this.alerts.filter((alert, index) => {
      const lastErrorTime = this.errorTimeStamps[alert.status];
      return now - lastErrorTime < ALERT_MESSAGE.TIMER;
    });

    const existingAlertIndex = this.alerts.findIndex(
      (alert) => alert.status === error_id
    );

    if (existingAlertIndex > -1) {
      const lastErrorTime = this.errorTimeStamps[error_id];
      if (now - lastErrorTime < ALERT_MESSAGE.TIMER) {
        this.alerts[existingAlertIndex].count++;
      } else {
        this.alerts[existingAlertIndex].count = 1;
      }
      this.errorTimeStamps[error_id] = now;
    } else {
      this.alerts.push({
        status: error_id,
        message: errorMessage,
        count: 1,
        detail: errorDetail,
      });
      this.errorTimeStamps[error_id] = now;
    }

    this.notifySubscribers();
  }
}

const errorService = new ErrorService();
export default errorService;
